import angular from "angular";
import userService from './user.service';

let userModule = angular.module('user.service', [])
.service('User', userService)

.name;

export default userModule;



// WEBPACK FOOTER //
// ./client/app/services/userService/user.js